import { ParticipantModel } from './participant.model';
import { SapOrderModel } from './sap-order.model';
import { WorkVersionModel } from './work-versions.model';
import { WorkAddonsModel } from './work-addons-model';
import { WorkRestrictionModel } from './work-restrictions-model';
import { WorkThemeModel } from './work-theme.model';
import { WorkGenreModel } from './work-genre.model';
import { WorkLanguageModel } from './work-language.model';
import { ColorModel } from './color.model';
import { QuotaModel } from './quota.model';
import { SoundModel } from './sound.model';
import { FormatModel } from './format.model';
import { WorkAppartenanceModel } from './work-appartenance.model';
import { FormatImageModel } from './format-image.model';
import { ProjectStatusModel } from './project-status.model';
import { FormatTypeModel } from './format-type.model';
import { WorkYearProductionModel } from './work-year-production.model';
import { EditorialContentModel } from './editorial-content.model';
import { KeywordsModel } from './keywords.model';

/**
 * Created by vsliwka on 05/04/2017.
 */
export class WorkModel {
  public id: number;
  public titleVO: string;
  public territory: string;
  public duration: any;
  public expired: boolean;
  public episodeNumber: number;
  public clientLanguageTitle: string;
  public title: string;
  public completeTitle: string;
  public miloCode: string;
  public isoCode: string;
  public eidrCode: string;
  public idIMDB: string;
  public workType: string;
  public yearOfProduction: WorkYearProductionModel;
  public director: string;
  public participants: ParticipantModel[];
  public sapOrders: SapOrderModel[];
  public versions: WorkVersionModel[];
  public addons: WorkAddonsModel[];
  public tvRestrictions: WorkRestrictionModel[];
  public movieRestrictions: WorkRestrictionModel[];
  public themes: WorkThemeModel[];
  public genres: WorkGenreModel[];
  public languages: WorkLanguageModel[];
  public arthouse: string;
  public color: ColorModel;
  public quota: QuotaModel;
  public sound: SoundModel;
  public format: FormatModel;
  public workAppartenance: WorkAppartenanceModel;
  public formatImage: FormatImageModel;
  public projectStatus: ProjectStatusModel;
  public formatType: FormatTypeModel;
  public genresSelected: any[] = [];
  public themesSelected: any[] = [];
  public languageSelected: any[] = [];
  public sapOrderId: number;
  public customOrderLabel: string;
  public percentage: number;
  public keyInSession = 'Referential-WorkModel-Session-key';
  public editorialContents: EditorialContentModel[];
  public workKeywords: KeywordsModel[];
  public exportableSap = false;
  public header: boolean;
  public seriesWorkId?: number;

  constructor() {
    this.versions = [];
  }

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
